// src/utils/fenixIcons.ts
import React from 'react';

// 1. Importa todos los íconos usando la sintaxis correcta (sin llaves)
import Add from '@pedidosya/web-fenix/icons/Add';
import AddBusiness from '@pedidosya/web-fenix/icons/AddBusiness';
import AddNote from '@pedidosya/web-fenix/icons/AddNote';
import AddOcta from '@pedidosya/web-fenix/icons/AddOcta';
import AddressPinA from '@pedidosya/web-fenix/icons/AddressPinA';
import AddressPinB from '@pedidosya/web-fenix/icons/AddressPinB';
import AI from '@pedidosya/web-fenix/icons/AI';
import Alert from '@pedidosya/web-fenix/icons/Alert';
import ArrowDown from '@pedidosya/web-fenix/icons/ArrowDown';
import ArrowLeft from '@pedidosya/web-fenix/icons/ArrowLeft';
import ArrowRight from '@pedidosya/web-fenix/icons/ArrowRight';
import ArrowUp from '@pedidosya/web-fenix/icons/ArrowUp';
import Bank from '@pedidosya/web-fenix/icons/Bank';
import Basket from '@pedidosya/web-fenix/icons/Basket';
import Book from '@pedidosya/web-fenix/icons/Book';
import BoxDrop from '@pedidosya/web-fenix/icons/BoxDrop';
import BoxPickUp from '@pedidosya/web-fenix/icons/BoxPickUp';
import BrandPedidosYa from '@pedidosya/web-fenix/icons/BrandPedidosYa';
import BrandPeyaPlus from '@pedidosya/web-fenix/icons/BrandPeyaPlus';
import BrandPeyaPlusInverted from '@pedidosya/web-fenix/icons/BrandPeyaPlusInverted';
import Briefcase from '@pedidosya/web-fenix/icons/Briefcase';
import Calendar from '@pedidosya/web-fenix/icons/Calendar';
import Camera from '@pedidosya/web-fenix/icons/Camera';
import CardIcon from '@pedidosya/web-fenix/icons/CardIcon';
import CardScanner from '@pedidosya/web-fenix/icons/CardScanner';
import Cart from '@pedidosya/web-fenix/icons/Cart';
import Cash from '@pedidosya/web-fenix/icons/Cash';
import ChangeCountry from '@pedidosya/web-fenix/icons/ChangeCountry';
import Chat from '@pedidosya/web-fenix/icons/Chat';
import Check from '@pedidosya/web-fenix/icons/Check';
import ChevronDown from '@pedidosya/web-fenix/icons/ChevronDown';
import ChevronLeft from '@pedidosya/web-fenix/icons/ChevronLeft';
import ChevronRight from '@pedidosya/web-fenix/icons/ChevronRight';
import ChevronUp from '@pedidosya/web-fenix/icons/ChevronUp';
import CircleCheck from '@pedidosya/web-fenix/icons/CircleCheck';
import Close from '@pedidosya/web-fenix/icons/Close';
import Coffee from '@pedidosya/web-fenix/icons/Coffee';
import Comment from '@pedidosya/web-fenix/icons/Comment';
import Confetti from '@pedidosya/web-fenix/icons/Confetti';
import Coupon from '@pedidosya/web-fenix/icons/Coupon';
import Crown from '@pedidosya/web-fenix/icons/Crown';
import Cutlery from '@pedidosya/web-fenix/icons/Cutlery';
import Delete from '@pedidosya/web-fenix/icons/Delete';
import DeliveryBike from '@pedidosya/web-fenix/icons/DeliveryBike';
import DeliveryCar from '@pedidosya/web-fenix/icons/DeliveryCar';
import DeliveryMotorcycle from '@pedidosya/web-fenix/icons/DeliveryMotorcycle';
import DineIn from '@pedidosya/web-fenix/icons/DineIn';
import Discount from '@pedidosya/web-fenix/icons/Discount';
import Dislike from '@pedidosya/web-fenix/icons/Dislike';
import Donation from '@pedidosya/web-fenix/icons/Donation';
import Drink from '@pedidosya/web-fenix/icons/Drink';
import Edit from '@pedidosya/web-fenix/icons/Edit';
import Email from '@pedidosya/web-fenix/icons/Email';
import EmptyState from '@pedidosya/web-fenix/icons/EmptyState';
import Favorite from '@pedidosya/web-fenix/icons/Favorite';
import FenixIcon from '@pedidosya/web-fenix/icons/FenixIcon';
import Filter from '@pedidosya/web-fenix/icons/Filter';
import Fleet from '@pedidosya/web-fenix/icons/Fleet';
import Gift from '@pedidosya/web-fenix/icons/Gift';
import HelmetRider from '@pedidosya/web-fenix/icons/HelmetRider';
import Help from '@pedidosya/web-fenix/icons/Help';
import HelpCenter from '@pedidosya/web-fenix/icons/HelpCenter';
import HelpSupport from '@pedidosya/web-fenix/icons/HelpSupport';
import Hidden from '@pedidosya/web-fenix/icons/Hidden';
import HigherPrice from '@pedidosya/web-fenix/icons/HigherPrice';
import Home from '@pedidosya/web-fenix/icons/Home';
import IceCream from '@pedidosya/web-fenix/icons/IceCream';
import ImageZoom from '@pedidosya/web-fenix/icons/ImageZoom';
import Information from '@pedidosya/web-fenix/icons/Information';
import Invoice from '@pedidosya/web-fenix/icons/Invoice';
import Landscape from '@pedidosya/web-fenix/icons/Landscape';
import Lightning from '@pedidosya/web-fenix/icons/Lightning';
import Like from '@pedidosya/web-fenix/icons/Like';
import List from '@pedidosya/web-fenix/icons/List';
import ListAI from '@pedidosya/web-fenix/icons/ListAI';
import Loader from '@pedidosya/web-fenix/icons/Loader';
import LocalesDestacados from '@pedidosya/web-fenix/icons/LocalesDestacados';
import Location from '@pedidosya/web-fenix/icons/Location';
import Lock from '@pedidosya/web-fenix/icons/Lock';
import LogIn from '@pedidosya/web-fenix/icons/LogIn';
import LogoApple from '@pedidosya/web-fenix/icons/LogoApple';
import LogoFacebook from '@pedidosya/web-fenix/icons/LogoFacebook';
import LogoGoogle from '@pedidosya/web-fenix/icons/LogoGoogle';
import LogOut from '@pedidosya/web-fenix/icons/LogOut';
import LowerPrice from '@pedidosya/web-fenix/icons/LowerPrice';
import Map from '@pedidosya/web-fenix/icons/Map';
import Medal from '@pedidosya/web-fenix/icons/Medal';
import Menu from '@pedidosya/web-fenix/icons/Menu';
import Mic from '@pedidosya/web-fenix/icons/Mic';
import MyLocation from '@pedidosya/web-fenix/icons/MyLocation';
import NewsCenter from '@pedidosya/web-fenix/icons/NewsCenter';
import NoCigarette from '@pedidosya/web-fenix/icons/NoCigarette';
import NoPicture from '@pedidosya/web-fenix/icons/NoPicture';
import Notification from '@pedidosya/web-fenix/icons/Notification';
import Order from '@pedidosya/web-fenix/icons/Order';
import OrderCancelled from '@pedidosya/web-fenix/icons/OrderCancelled';
import Organic from '@pedidosya/web-fenix/icons/Organic';
import PedidosYaPay from '@pedidosya/web-fenix/icons/PedidosYaPay';
import Pharma from '@pedidosya/web-fenix/icons/Pharma';
import Phone from '@pedidosya/web-fenix/icons/Phone';
import PickUp from '@pedidosya/web-fenix/icons/PickUp';
import Picture from '@pedidosya/web-fenix/icons/Picture';
import PinMap from '@pedidosya/web-fenix/icons/PinMap';
import PreOrder from '@pedidosya/web-fenix/icons/PreOrder';
import QrScanner from '@pedidosya/web-fenix/icons/QrScanner';
import RatingIcon from '@pedidosya/web-fenix/icons/RatingIcon';
import RecentSearch from '@pedidosya/web-fenix/icons/RecentSearch';
import Refound from '@pedidosya/web-fenix/icons/Refound';
import Reload from '@pedidosya/web-fenix/icons/Reload';
import Remove from '@pedidosya/web-fenix/icons/Remove';
import RemoveOcta from '@pedidosya/web-fenix/icons/RemoveOcta';
import Saved from '@pedidosya/web-fenix/icons/Saved';
import SavedLocations from '@pedidosya/web-fenix/icons/SavedLocations';
import Search from '@pedidosya/web-fenix/icons/Search';
import Section from '@pedidosya/web-fenix/icons/Section';
import Security from '@pedidosya/web-fenix/icons/Security';
import Settings from '@pedidosya/web-fenix/icons/Settings';
import ShareAndroid from '@pedidosya/web-fenix/icons/ShareAndroid';
import ShareIos from '@pedidosya/web-fenix/icons/ShareIos';
import Sort from '@pedidosya/web-fenix/icons/Sort';
import Stamp from '@pedidosya/web-fenix/icons/Stamp';
import StopWatch from '@pedidosya/web-fenix/icons/StopWatch';
import Telephone from '@pedidosya/web-fenix/icons/Telephone';
import ThreeDots from '@pedidosya/web-fenix/icons/ThreeDots';
import ThreeDotsHorizontally from '@pedidosya/web-fenix/icons/ThreeDotsHorizontally';
import Time from '@pedidosya/web-fenix/icons/Time';
import TimeFast from '@pedidosya/web-fenix/icons/TimeFast';
import TimeSlow from '@pedidosya/web-fenix/icons/TimeSlow';
import Trophy from '@pedidosya/web-fenix/icons/Trophy';
import Unlock from '@pedidosya/web-fenix/icons/Unlock';
import User from '@pedidosya/web-fenix/icons/User';
import Vegan from '@pedidosya/web-fenix/icons/Vegan';
import Vegetarian from '@pedidosya/web-fenix/icons/Vegetarian';
import Visibility from '@pedidosya/web-fenix/icons/Visibility';
import Warning from '@pedidosya/web-fenix/icons/Warning';

// 2. Crea un objeto que mapee el nombre del ícono al componente importado
export const fenixIconMap = {
  Add,
  AddBusiness,
  AddNote,
  AddOcta,
  AddressPinA,
  AddressPinB,
  AI,
  Alert,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Bank,
  Basket,
  Book,
  BoxDrop,
  BoxPickUp,
  BrandPedidosya: BrandPedidosYa,
  BrandPeyaPlus,
  BrandPeyaPlusInverted,
  Briefcase,
  Calendar,
  Camera,
  CardIcon,
  CardScanner,
  Cart,
  Cash,
  ChangeCountry,
  Chat,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleCheck,
  Close,
  Coffee,
  Comment,
  Confetti,
  Coupon,
  Crown,
  Cutlery,
  Delete,
  DeliveryBike,
  DeliveryCar,
  DeliveryMotorcycle,
  DineIn,
  Discount,
  Dislike,
  Donation,
  Drink,
  Edit,
  Email,
  EmptyState,
  Favorite,
  FenixIcon,
  Filter,
  Fleet,
  Gift,
  HelmetRider,
  Help,
  HelpCenter,
  HelpSupport,
  Hidden,
  HigherPrice,
  Home,
  IceCream,
  ImageZoom,
  Information,
  Invoice,
  Landscape,
  Lightning,
  Like,
  List,
  ListAI,
  Loader,
  LocalesDestacados,
  Location,
  Lock,
  LogIn,
  LogoApple,
  LogoFacebook,
  LogoGoogle,
  LogOut,
  LowerPrice,
  Map,
  Medal,
  Menu,
  Mic,
  MyLocation,
  NewsCenter,
  NoCigarette,
  NoPicture,
  Notification,
  Order,
  OrderCancelled,
  Organic,
  PedidosYaPay,
  Pharma,
  Phone,
  PickUp,
  Picture,
  PinMap,
  PreOrder,
  QrScanner,
  RatingIcon,
  RecentSearch,
  Refound,
  Reload,
  Remove,
  RemoveOcta,
  Saved,
  SavedLocations,
  Search,
  Section,
  Security,
  Settings,
  ShareAndroid,
  ShareIos,
  Sort,
  Stamp,
  StopWatch,
  Telephone,
  ThreeDots,
  ThreeDotsHorizontally,
  Time,
  TimeFast,
  TimeSlow,
  Trophy,
  Unlock,
  User,
  Vegan,
  Vegetarian,
  Visibility,
  Warning,
};

export type FenixIconName = keyof typeof fenixIconMap;

/**
 * Renderiza un componente de ícono de Fenix dinámicamente basado en un string.
 * @param iconString - El string del backend (ej. "Add_outline", "Alert_filled").
 * @returns Un componente de React del ícono con las props correctas, o null si no se encuentra.
 */
export const renderFenixIcon = (
  iconString: string | null | undefined,
): React.ReactNode => {
  if (!iconString) {
    return null;
  }

  const IconComponent = fenixIconMap[iconString as FenixIconName];

  if (!IconComponent) {
    console.warn(`Icono "${iconString}" no encontrado en fenixIconMap.`);
    return null;
  }

  return React.createElement(IconComponent);
};
